import React, { useState, useEffect } from 'react';
import { useAppDispatch } from '../../../../hooks/redux';
import {
    AddProductsFromMfrChoiceTemplateModal,
    AddFromMfrChoiceTemplateSpace,
} from './AddFromMfrChoiceTemplateModal.styles';
import { Text, CloseIcon } from '../../../../styles/common.styles';
import ModalTitle from '../../../common/modalTitle/ModalTitle';
import ModalFooter from '../../../common/modalFooter/ModalFooter';
import { blueDark01 } from '../../../../styles/colors';
import { Form } from 'antd';
import { getProjectLibraryAction } from '../../../../redux/actions/projectActions';
import { GetProjectLibraryRequest } from '../../../../redux/actions/projectActions/types';
import { Project } from '../../../../models/project/types';
import { SelectData } from '../../../../models/common/types';
import CustomSelectWithSearch from '../../../common/select/CustomSelectWithSearch';

interface Props {
    isOpen: boolean;
    projectId?: number;
    closeModal: (data: { key: 'mfrChoiceTemplate' }) => void;
}

const AddFromMfrChoiceTemplateModal: React.FC<Props> = ({ isOpen, closeModal, projectId }) => {
    const dispatch = useAppDispatch();

    const [templateOptions, setTemplateOptions] = useState<SelectData[]>([]);

    useEffect(() => {
        const fetchTemplates = async () => {
            const request: GetProjectLibraryRequest = {
                status: 'ManufacturerTemplate',
                curPage: 1,
                pageSize: 1000,
                searchString: '',
                sortDirection: 'asc',
                sortExpression: null,
            };

            const { payload } = (await dispatch(getProjectLibraryAction(request))) as { payload: any };

            const mfrChoiceTemplates: Project[] = payload?.projects ?? [];

            setTemplateOptions(
                mfrChoiceTemplates
                    .map((t) => ({ id: t.id.toString(), name: t.name }))
                    .sort((a, b) => a.name.localeCompare(b.name)),
            );
        };

        fetchTemplates();
    }, [dispatch]);

    const handleCancel = () => closeModal({ key: 'mfrChoiceTemplate' });

    const onSubmit = (data: { selectedTemplate: string }) => {
        if (data.selectedTemplate) {
            window.location.href = `/project-info/${data.selectedTemplate}/0/2?copyProductsTo=${projectId}`;
        }
    };

    return (
        <AddProductsFromMfrChoiceTemplateModal
            open={isOpen}
            onCancel={handleCancel}
            closeIcon={<CloseIcon />}
            centered
            footer={null}
        >
            <ModalTitle
                title="Select a Manufacturer's Choice Template"
                icon="ic-modal-title-start-add-project.svg"
            />
            <Text weight={400} size={15} height={20} color={blueDark01}>
                Select the Manufacturer's Choice Template with the products you want to add.
            </Text>
            <Form onFinish={onSubmit}>
                <AddFromMfrChoiceTemplateSpace>
                    <CustomSelectWithSearch
                        id="MfrChoiceTemplatesToCopySelectModal"
                        label="Select Template"
                        name="selectedTemplate"
                        options={templateOptions}
                        placeholder="Select one"
                        rules={[{ message: '' }]}
                        block
                        modallabel
                    />
                </AddFromMfrChoiceTemplateSpace>
                <ModalFooter
                    action="Next"
                    cancel={handleCancel}
                    cancelText="Cancel"
                    submit={() => {}}
                />
            </Form>
        </AddProductsFromMfrChoiceTemplateModal>
    );
};

export default AddFromMfrChoiceTemplateModal;
